import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "@phosphor-icons/react";

type BottomDrawerProps = {
	open: boolean;
	onClose: () => void;
	children: React.ReactNode;
	showCloseButton?: boolean;
	closeOnBackdrop?: boolean;
	heightClassName?: string;
};

const BottomDrawer = ({
	open,
	onClose,
	children,
	showCloseButton = true,
	closeOnBackdrop = true,
	heightClassName = "max-h-[85vh]"
}: BottomDrawerProps) => {
	useEffect(() => {
		if (open) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "";
		}

		return () => {
			document.body.style.overflow = "";
		};
	}, [open]);

	if (!open) return null;

	return createPortal(
		<div className="fixed inset-0 z-50 flex items-end justify-center">
			<div
				className="absolute inset-0 bg-black/50 transition-opacity duration-200"
				onClick={closeOnBackdrop ? onClose : undefined}
			/>

			<div className="relative w-full">
				{showCloseButton && (
					<button
						onClick={onClose}
						className="
						absolute -top-14
						left-1/2 -translate-x-1/2
						bg-white
						rounded-full
						shadow-xl
						w-11 h-11
						flex items-center justify-center
						text-gray-700 hover:text-black
						transition
					">
						<X size={22} weight="bold" />
					</button>
				)}
				<div
					className={`
					relative w-full bg-white rounded-t-2xl shadow-xl
					slide-up-drawer ${heightClassName} overflow-y-auto
				`}>
					<div className="flex justify-center pt-3 pb-2">
						<div className="h-1.5 w-10 rounded-full bg-gray-300" />
					</div>

					<div className="px-5 pb-6">{children}</div>
				</div>
			</div>
		</div>,
		document.body
	);
};

export default BottomDrawer;
